export const BILLING_TAB_CONFIG = [
  { id: "overview", label: "Overview", to: "/billing/$projectId/overview" },
  { id: "invoices", label: "Invoices", to: "/billing/$projectId/invoices" },
  {
    id: "payment-methods",
    label: "Payment methods",
    to: "/billing/$projectId/payment-methods",
  },
  {
    id: "history",
    label: "Subscription history",
    to: "/billing/$projectId/history",
  },
] as const;
